import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Stack, Typography } from "@mui/material";
import { PlayerAvatar } from "./PlayerAvatar";
import { PlayerDisplayNameLink } from "./PlayerDisplayNameLink";
export var PlayerView = function (_a) {
    var player = _a.player, _b = _a.variant, variant = _b === void 0 ? "h5" : _b;
    return (_jsxs(Stack, { direction: "row", spacing: 2, alignItems: "center", children: [_jsx(PlayerAvatar, { player: player }), _jsx(Typography, { variant: variant, children: _jsx(PlayerDisplayNameLink, { player: player }) })] }));
};
